"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryPrice = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const useInject_1 = require("./useInject");
const DEBOUNCE_QUERY_PRICE_TIME = 500;
/**
 * 提供一个用于询价的异步接口，该hook会对它进行封装，增强以下能力
 * 1、在选购页表单中获取必要的价格因子和它的取值
 * 2、静态参数补充
 * 3、获取当前价格
 * 4、返回价格计算公式？（如果有）
 */
function useQueryPrice({ orderItem_ }, props, injectModule) {
    // 询价会有两种场景：1、针对可选项展示价格和优惠；2、针对已选择的商品展示最后的价格
    const { getPriceBySpu, useExternalParameter = false } = props !== null && props !== void 0 ? props : {};
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [result, setResult] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)(null);
    // 绑定询价操作
    (0, react_1.useEffect)(() => {
        if (getPriceBySpu) {
            const queryPriceSub = orderItem_
                .pipe((0, rxjs_1.debounceTime)(DEBOUNCE_QUERY_PRICE_TIME), (0, rxjs_1.tap)(() => {
                setLoading(true);
                setError(null);
            }), (0, rxjs_1.switchMap)(orderItem => {
                const { SpuItem, ExternalParameterList } = orderItem;
                const req = useExternalParameter ? { SpuItem, ExternalParameterList } : { SpuItem };
                return (0, rxjs_1.from)((0, useInject_1.injectAsyncRunner)(getPriceBySpu, [req], injectModule)).pipe((0, rxjs_1.catchError)(err => {
                    setLoading(false);
                    setError(err);
                    return rxjs_1.EMPTY;
                }));
            }), (0, rxjs_1.tap)(() => setLoading(false)))
                .subscribe(setResult);
            return () => {
                queryPriceSub.unsubscribe();
            };
        }
    }, [getPriceBySpu, orderItem_, useExternalParameter, injectModule]);
    return { result, loading, error };
}
exports.useQueryPrice = useQueryPrice;
